export function mergeWidgetParams(url, conf) {
  conf.callback = url.searchParams.get('callback');
  conf.root = url.searchParams.get('node') ?? 'IndigoAINode';
  conf.init = url.searchParams.get('init') ?? 'init';
  const autostartParam = url.searchParams.get('autostart');
  conf.autostart = !(autostartParam && autostartParam !== 'on');
  const scrollPassthrough = url.searchParams.get('scroll_passthrough');
  conf.scrollPassthrough = scrollPassthrough === 'on';
  if (url.searchParams.get('trigger') === 'off' && conf.data) {
    conf.data.no_floating_button = true;
  }
}
